import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import RecotizacionesTable from "../components/RecotizacionesTable";
import { useGlobalContext } from "../Config";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";

const Recotizacion = (props) => {
  const [asignaciones, setAsignaciones] = useState([]);
  const [tableData, setTableData] = useState(asignaciones);
  const [activeTab] = useState("Vigentes");
  const [filters2] = useState(null);
  const [loading2, setLoading2] = useState(true);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [fila, setFila] = useState(null);
  const [producto, setProducto] = useState(null);
  const { baseUrl } = useGlobalContext();
  const estados = ["A", "E"];
  const usuarioId = sessionStorage.getItem("usuario_id");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const formatDate = (value) => {
    return value.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  const buildAsignacionesUrl = (usuarioId) => {
    return `${baseUrl}getCotizacionesByEstados?idUsuario=${usuarioId}&estados=${[
      "7"
    ]}`;
  };
  const fetchData = async (url) => {
    const requestOptions = {
      method: "GET",
      headers: new Headers(),
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(
        `Network response was not ok. Status: ${response.status}`
      );
    }

    return response.json();
  };


  useEffect(() => {
    const getAsignaciones = async () => {
      try {
        setLoading2(true);
        const url = buildAsignacionesUrl(usuarioId);
        const data = await fetchData(url);
        if (Array.isArray(data.cotizaciones)) {
          // Update all states at once
          setAsignaciones(data.cotizaciones);
          setTableData(data.cotizaciones);
        } else {
          console.error("Data.cotizaciones no es array:", data.cotizaciones);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading2(false);
      }
    };
    getAsignaciones();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  const desdeBodyTemplate = (rowData) => {
    return formatDate(rowData.desde);
  };

  const hastaBodyTemplate = (rowData) => {
    return formatDate(rowData.hasta);
  };

  const estadoBodyTemplate = (rowData) => {
    return (
      <span className={`customer-badge status-${rowData.estado}`}>
        {rowData.estado}
      </span>
    );
  };

  const estadoFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={estados}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        itemTemplate={statusItemTemplate}
        placeholder="Select a Status"
        className="p-column-filter"
        showClear
      />
    );
  };

  const statusItemTemplate = (option) => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button
          icon="pi pi-eye"
          label="Ver detalles"
          className="p-button-rounded p-button-info p-button mr-2 mb-2 mt-2"
          outlined
          onClick={() => handleRowClick(rowData)}
        />
      </div>
    );
  };

  const buildDetalleCotizacionUrl = (idCotizacion) => {
    return `${baseUrl}getDetalleCotizacionByIdCotizacion?idCotizacion=${idCotizacion}`;
  };
  const handleRowClick = async (rowData) => {
    const idCotizacion = rowData.id;

    // Function to format date, ensuring the output is always in 'yyyy-mm-dd'
    const formatDate = (date, inputFormat) => {
      const parsedDate = moment(date, inputFormat);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
    };

    const formattedDesde = formatDate(rowData.desde, "DD/MM/YYYY");
    const formattedHasta = formatDate(rowData.hasta, "DD/MM/YYYY");

    if (rowData.estado.estado === "INGRESADA") {
      let newUrl = `/selectProductos?idCotizacion=${idCotizacion}&idCliente=${rowData.cliente.id}&selected=true&activeIndex=1`;
      navigate(newUrl);
    } else {
      try {
        setLoading(true);
        const detalleCotizacionUrl = buildDetalleCotizacionUrl(idCotizacion);

        const data = await fetchData(detalleCotizacionUrl);

        if (data.mensaje === "OK") {
          const encodedParams = data.detalles
            .map((item) => {
              // Omit 'desde' and 'hasta' properties
              const { ...rest } = item;
              // Convert the object to a URL parameter string
              return encodeURIComponent(JSON.stringify(rest));
            })
            .join(",");

          let newUrl = `/revisarCotizacion?idCliente=${rowData.cliente.id}&idCotizacion=${idCotizacion}&desde=${formattedDesde}&hasta=${formattedHasta}`;
          navigate(newUrl);
        } else {
          alert(data.mensaje);
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message);
        } else {
          alert("Hubo un error al crear la cotización");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="grid table-demo">
      <div className="col-12">
        <div className="card">
          <h4 style={{ marginBottom: "5px" }}>Recotizaciones</h4>
          <h6 style={{ marginTop: "5px" }}>¿Qué Asignaciones han sido modificadas?</h6>
        </div>  
      </div>

      <RecotizacionesTable
        activeTab={activeTab}
        recotizaciones={tableData}
        filters={filters2}
        loading={loading || loading2}
        desdeBodyTemplate={desdeBodyTemplate}
        dateFilterTemplate={dateFilterTemplate}
        hastaBodyTemplate={hastaBodyTemplate}
        estadoBodyTemplate={estadoBodyTemplate}
        estadoFilterTemplate={estadoFilterTemplate}
        actionBodyTemplate={actionBodyTemplate}
        setDisplayBasic={setDisplayBasic}
        displayBasic={displayBasic}
        fila={fila}
        setFila={setFila}
        producto={producto}
        setProducto={setProducto}
        handleRowClick={handleRowClick}
      ></RecotizacionesTable>
    </div>
  );
};

export default Recotizacion;
